module.exports = __webpack_public_path__ + "static/media/wizualizacja-148.a792aba1.png";